<template>
    <div class="form-field">
        <label>{{data.name}}</label>
        <div class="content">
            <div class="view-upload-image" :class="classNames" ref="elm">
                <div class="inner">
                    <input type="file" ref="file" @change="onUploadImage"/>
                    <div class="inner-content" v-if="url" :style="imageStyle"></div>
                    <div class="overlay" @click="onClick">
                        <div class="icon">
                            <img src="../../assets/images/replace.svg"/>
                        </div>
                        <div>替换</div>
                    </div>
                </div>
            </div>
            <el-checkbox :value="isDynamic" @input="changeDynamic">动态</el-checkbox>
        </div>
    </div>
</template>
<style lang="scss" scoped>

    .form-field {
        align-items: flex-start;
        > label {
            padding-right: 10px;
        }
    }

    .content {
        padding-right: 20px;
        display: flex;
        align-items: flex-end;
    }

    .view-upload-image {
        width: 100%;
        box-sizing: border-box;
        padding: 12px;
        display: inline-block;
        position: relative;
        color: #bebebe;
        cursor: pointer;
        height: 100%;
        min-height: 100px;
        margin-right: 10px;
        border-radius: 6px;
        overflow: hidden;
        border: 1px solid #DDD;
        background: #FFF;
        .inner {
            height: 100px;
            position: relative;
            background: url(data:image/png;base64,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);
        }
        input {
            display: none;
        }

        .inner-content {
            background-repeat: no-repeat;
            background-size: cover;
            pointer-events: none;
            width: 100%;
            height:100px;
            min-height: 100px;
            background-position: center;
        }
        .overlay {
            top:0;
            width:100%;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            height: 100px;
            color:#FFF;
            .icon{
                width:48px;
                height:48px;
                background: rgba(0,0,0,.48);
                border:1px solid rgba(255,255,255,.5);
                border-radius:50%;
                position: relative;
                display: flex;
                justify-content: center;
                align-items: center;
            }
        }

        &.error {
            > .empty-view {
                background: rgba(255, 0, 0, 0.4) !important;
                border: dashed 1px red;
                > .mu-icon {
                    color: red;
                }
            }
        }
    }

</style>

<script>
	import _ from 'lodash'
	import upload from 'mixins/upload'
	import config from 'utils/config'
	import {convertImage} from 'utils/helper'

	export default {
		props: [ 'data' ],
		mixins: [ upload ],
		data: function () {
			return {
				image: null,
				checked: false
			}
		},
		mounted() {
			this.loadImage()
		},
		beforeDestroy() {
			this.clearItem()
		},
		computed: {
			url(){
			    return this.data.sampleUrl
            },
            isDynamic(){
			    return this.$store.state.slots.findIndex(item => item.name === '##' + this.data.name)>=0
            },
			classNames() {
				return {
					pending: this.pending,
					error: this.failure
				}
			},
			imageStyle() {
				if (this.url) {
					var style = {
						backgroundImage: `url(${this.url})`
					}
					return style
				} else {
					return {}
				}
			}
		},
		methods: {
			loadImage() {
				if (this.url) {
					this.pending = true
					this.image = new Image()
					this.image.src = this.url
				} else {
					this.image = null
				}
			},
			clearItem() {
				if (this.image) {
					this.image = null
				}
			},
			onClick() {
				this.$refs.file.click()
			},
			clearFile() {
				this.$refs.file.value = ""
			},
			onUploadImage(e) {
				const file = e.target.files[ 0 ]
				// 检查文件类型和文件大小
				let file_size = false
				let file_type = false
				if (file.size > 1024 * 1024) {
					file_size = true
				} else if (!/image\/(\w+)/.test(file.type)) {
					file_type = true
				}

				if (file_type) {
					this.$alert('文件类型有误！', {
						title: '温馨提示',
						customClass: 'alert',
						confirmButtonText: '确定'
					});
				}
				if (file_size) {
					this.$alert('文件大小过大！', {
						title: '温馨提示',
						customClass: 'alert',
						confirmButtonText: '确定'
					});
				}
				if (!file_size && !file_type) {
					this.uploadFile(file).then((url) => {
						this.$store.commit('update_ae_elm', {
							name: this.data.name,
							sampleUrl:url
						})
						this.clearFile()
					})
				} else {
					this.clearFile()
				}
			},
			changeDynamic(v){
				this.$store.commit('update_ae_dynamic', {
					name: this.data.name,
					isDynamic: v
				})
            }
		},
		watch: {
			url() {
				this.loadImage()
			}
		}
	}
</script>
